import { TaskType } from '@nexelem/graphne-api';
import { getTaskTypeIcon } from './getTaskTypeIcon';

type TaskTypeIconProps = {
  taskType: TaskType;
  className?: string;
};

export const TaskTypeIcon = ({ taskType, className }: TaskTypeIconProps) => {
  const IconComponent = getTaskTypeIcon(taskType) || (() => null);
  return <IconComponent className={className} />;
};
